import React, { Component } from 'react';
import networkList from '../../constants/networkList';
import postService from './../../services/httpService';
const $ = require('jquery');
const {homepage} = networkList;
var url = window.location.href
var arr = url.split("/");
var hostname = arr[0] + "//" + arr[2]

class NurseStation extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            'loadding': false,
            tableHead: [],           
            tableData: []
        }
    }

    componentDidMount() {
        this.setState({loadding: true });
        const params = new URLSearchParams(this.props.location.search);
      const unitid= params.get('unit_id');
        let tableHead = [{
            'key': 'nurse_station',
            'text': 'Nurse Station'
        },{
            'key': 'ns_code',
            'text': 'Nurse Station Code'
        } ,
         {
            'key': 'unitname',
            'text': 'Unit Name'
        }, {
            'key': 'tv_url',
            'text': 'TV URL'
        } 
        ];
        let { getNurseStationsWithNoAuth } = networkList;
        postService(getNurseStationsWithNoAuth, 'POST', { "data": { "unitid": unitid } }).then((res) => {  
            if(res.status){
             this.setState({tableData:res.data,'tableHead':tableHead,loadding:false })
            }
            else{
                this.setState((state) => ({
                    'tableData': [],'tableHead':tableHead,loadding:false
                }))
            }  
        })
    }
    render() {
        let { tableData,tableHead } = this.state;
        return (
            <div className="ml-5 mr-5 mb-5">
                    <div className="financial-table table-responsive">
                            <table className="table table-hover table-bordered mb-0">
                            <thead>
                                <tr>
                                    <td>S.no</td>
                                    {tableHead.map((head, key) => {
                                            return (<td key={key}>{head.text}</td>);
                                    })}
                                </tr>
                            </thead>
                            <tbody>
                                {tableData.map((body, key) => {
                                    return (<tr key={key}>
                                        {/* onClick={this.navigateTo.bind(this,body)} style={{cursor: 'pointer'}} */}
                                        <td className=" backgourd-color">{(key + 1) }</td>
                                        {tableHead.map((head, Hkey) => {
                                            if (head['key'] === 'tv_url') {
                                                return (<td  className="backgourd-color"
                                                // onClick={()=>{this.openNurseUrl(body) }}
                                                 >
                                                    <a href={homepage+'/nurse-display?ns_id='+ body['ns_code']+'&unit_id='+body['unit_id'] } target = "_blank" style={{color: '#455a64'}} >{body['ns_code'] ? `${hostname + homepage +'/nurse-display?ns_id='+ body['ns_code']+'&unit_id='+body['unit_id']}`: 'NA'}</a></td>)
                                            }
                                            return (
                                                <td className="text-capitalize backgourd-color">{(body[head['key']] !== null) ? body[head['key']] : 'NA'}</td>
                                            )

                                        })
                                        }

                                    </tr>)
                                })}
                                {(tableData && tableData.length === 0) && <React.Fragment>

                                    <tr>
                                        <td colSpan={tableHead.length + 1} className="text-center">
                                            <img src={homepage+"/assets/images/icons/no-data.svg"} alt="" />
                                            <p className="no-data mb-0">No Data</p>
                                        </td>
                                    </tr>

                                </React.Fragment>}
                            </tbody>
                        </table>
                    </div>
            </div>
        )
    }

}
export default NurseStation